<template>
  <div id="login_wrapper">
    <!--左侧登录界面-->
    <div class="left">
      <p>已注册用户从这里登录</p>
      <Form
        ref="formInline"
        :model="reset"
        :rules="ruleInline"
        :label-width="100"
      >
        <FormItem
          prop="user"
          label="用户名："
        >
          <Input
            type="text"
            v-model="reset.user"
            style="width:220px;float:left;"
            placeholder="邮箱/用户名/手机号"
          />

        </FormItem>
        <FormItem
          prop="password"
          label="新登录密码："
        >
          <Input
            type="password"
            v-model="reset.password"
            style="width:220px;float:left;"
            placeholder="至少6个字符"
          />

        </FormItem>
        <!-- <FormItem
          label="手机号码："
          prop="phone"
        >
          <Input
            type="text"
            style="width:220px;float:left;"
            v-model="reset.phone"
            placeholder="请输入手机号码"
          ></Input>
          <div
            v-if="!showSec"
            class="m_forget"
            style="cursor:pointer;margin-left: 30px;color:#1F7BF5;width:70px"
            @click="phoneCode"
          >获取验证码</div>
          <div
            v-else
            class="seconds"
          >已发送 ({{seconds}}S)</div>
        </FormItem> -->
        <FormItem
          prop="valCode"
          label="短信验证码："
        >
          <Input
            type="text"
            v-model="reset.valCode"
            @keyup.enter.native="resetPassword()"
            style="width:220px;float:left;"
            placeholder="请输入短信验证码"
          />
          <div
            v-if="!showSec"
            class="m_forget"
            style="cursor:pointer;margin-left: 30px;color:#1F7BF5;width:70px"
            @click="getMsgCode"
          >获取验证码</div>
          <div
            v-else
            class="m_forget"
            style="margin-left: 30px;width:70px"
          >已发送 ({{seconds}}S)</div>
        </FormItem>
        <FormItem style="margin-top:20px;">
          <Button
            @click="resetPassword()"
            type="error"
            size="large"
            style="width:200px;background-color:#F58B01"
          >重新设置</Button>
        </FormItem>
      </Form>
    </div>
    <!--左侧登录界面结束-->
    <!--中间竖线-->
    <div class="middle"></div>
    <!--中间竖线结束-->
    <!--右侧宣传-->
    <div class="right">
      <img
        src="../../assets/images/login-bg.png"
        class="pngFix"
      />
    </div>
    <!--右侧宣传结束-->
  </div>
</template>
<script>
import { resetPwd } from "api/user";
import { getNoSettleCode } from "api/order";
import encrypt from "encryptlong";
export default {
  data() {
    return {
      reset: {
        user: "",
        password: "",
        valCode: "",
        phone: "",
      },
      imgSrc: "",
      ruleInline: {
        user: [{ required: true, message: "此项为必填", trigger: "blur" }],
        password: [{ required: true, message: "此项为必填", trigger: "blur" }],
        valCode: [{ required: true, message: "此项为必填", trigger: "blur" }],
      },
      seconds: 60, //倒计时
      showSec: false,
      timer: undefined, //定时器id
      clickGetPhone: false,
    };
  },
  created() {},
  methods: {
    getMsgCode() {
      getNoSettleCode({
        loginName: this.reset.user,
        type: 3,
      }).then((res) => {
        this.showSec = true;
        this.countDown();
        if (res.resCode === 1) {
          this.$Message.success("已发送短信验证码");
          callback();
        } else {
          // 返回不成功
          callback(new Error(res.resDesc));
        }
      });
    },
    countDown() {
      const _this = this;
      this.timer = setInterval(function () {
        if (!_this.seconds) {
          clearInterval(_this.timer);
          _this.seconds = 60;
          _this.showSec = false;
          return;
        }
        _this.seconds -= 1;
      }, 1000);
    },
    // 登录
    resetPassword() {
      if (this.reset.user.trim() === "") {
        this.$Message.warning("请输入用户名");
        return;
      }
      if (this.reset.password.trim() === "") {
        this.$Message.warning("请输入新密码");
        return;
      }
      if (this.reset.valCode.trim() === "") {
        this.$Message.warning("请输入短信验证码");
        return;
      }
      const postJson = {
        loginName: this.reset.user,
        newPwd: this.reset.password,
        code: this.reset.valCode,
        platform: "GD",
        type: 3,
      };
      const publicKey = process.env.PUBLICKEY;
      let encryptor = new encrypt();
      encryptor.setPublicKey(publicKey);
      let postBody = encryptor.encryptLong(JSON.stringify(postJson));
      resetPwd(postBody).then((res) => {
        if (res.resCode == 1) {
          this.$Modal.success({
            content: "重置密码成功!",
            onOk: () => {
              this.$router.push({
                path: "/login",
              });
            },
          });
        } else {
          this.$Message.error(res.resDesc);
        }
      });
    },
  },
  destroy() {
    clearInterval(this.timer);
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?3e09589a